import Integrations from '@/shared/api/integrations';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchRipplingPayrollRuns = createAsyncThunk(
  'integrations/rippling/payrollRuns/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await Integrations.url('/rippling/payroll_runs').get();

      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);
